<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-start pt-4>
      <v-flex xs1 sm1 lg1 text-left align-self-center>
        <v-img
          src="./../../../assets/Images/agogo.png"
          contain
          height="30px"
        ></v-img>
      </v-flex>
      <v-flex xs8 sm2 lg3 text-left align-self-center>
        <span
          style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                  "
        >
          Search results <span v-if="Searched.length>0"> ({{ Searched.length }}) </span>
        </span>
      </v-flex>
      <v-spacer class="hidden-xs-only"></v-spacer>
      <v-flex xs3 lg4 px-10 align-self-center text-left>
        <v-text-field
          hide-details
          :color="appColor"
          placeholder="Search"
          height="30px"
          outlined
          dense
          append-icon="mdi-magnify"
          v-model="search"
          @change="getResult"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout wrap v-if="Searched.length > 0" pa-4>
      <template v-for="item in Searched">
        <v-flex xs12 xl11 :key="item.name" pr-lg-6 pr-xl-0>
          <SearchItem v-bind:storage="item" @stepper="winStepper" />
        </v-flex>
        <v-flex xs12 xl11 :key="item._id" py-4>
          <v-divider></v-divider>
        </v-flex>
      </template>
    </v-layout>

    <v-layout wrap v-else>
      <v-flex xs12 pa-12>
        <span>Oops! No results found.</span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import SearchItem from "./searchItem";
export default {
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      search: null,
      Searched:{}
    };
  },
  components: {
    SearchItem
  },
  computed: {
    // appSearchData() {
    //   return this.$store.state.searchData;
    // },
    // appSearch() {
    //   console.log("y",this.$store.state.searchData);
    //   return this.$store.state.searchData.data;
    // },
    appKeyword() {
      return localStorage.getItem("search");
    },
  },

  beforeMount() {
    if (this.appKeyword) this.search = this.appKeyword;
    this.getResult();
  },
  methods: {
     winStepper(window_data) {
      if (window_data.getData) {
        this.getResult();
      }
    },
    getResult() {
      this.appLoading = true;
      localStorage.setItem("search", this.search);
      axios({
        method: "POST",
        url: "/product/search",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          keyword: this.search,
          userid: localStorage.getItem('userid'),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$store.commit("searchedFor", response.data);
            this.Searched=response.data.data
            this.Searched = this.Searched.map((x) => {
              if (x.isColor) {
                x.colorDetails = x.colorDetails.map((y) => {
                  y.color = JSON.parse(y.color);
                  y.colorHex = y.color.toString(16);
                  y.colorHex = y.colorHex.substring(2);
                  y.colorHex = "#" + y.colorHex;
                  return y;
                });
              }
              return x;
            });
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
